import { render, staticRenderFns } from "./BizLocMonthlyEmissionByScope.vue?vue&type=template&id=5a2d83fb&scoped=true"
import script from "./BizLocMonthlyEmissionByScope.vue?vue&type=script&lang=js"
export * from "./BizLocMonthlyEmissionByScope.vue?vue&type=script&lang=js"
import style0 from "./BizLocMonthlyEmissionByScope.vue?vue&type=style&index=0&id=5a2d83fb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a2d83fb",
  null
  
)

export default component.exports